(function () {
  'use strict';

  var initialized = false;

  function getData() {
    var el = document.getElementById('cart-city-form-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('cart_city_form: invalid JSON data', e);
      return null;
    }
  }

  function showErrorMsg(message) {
    if (typeof Swal !== 'undefined') {
      Swal.fire({ icon: 'error', text: message });
    } else {
      alert(message);
    }
  }

  function removeAccentsAndSpecialChars(str) {
    var accentsMap = {
      á: 'a', é: 'e', í: 'i', ó: 'o', ú: 'u',
      à: 'a', è: 'e', ì: 'i', ò: 'o', ù: 'u',
      ä: 'a', ë: 'e', ï: 'i', ö: 'o', ü: 'u',
      â: 'a', ê: 'e', î: 'i', ô: 'o', û: 'u',
      ñ: 'n', ç: 'c', ß: 'ss'
    };

    return String(str).replace(/[^\w\s]/gi, function (char) {
      return accentsMap[char] || char;
    });
  }

  function urlFormatter(url, parameters) {
    var parts = url.split('?');
    var base = parts[0];
    var map = {};
    var newParameters = [];
    var i;

    if (parts[1] != null) {
      var oldParameters = parts[1].split('&');
      for (i = 0; i < oldParameters.length; i++) {
        var parameter = oldParameters[i].split('=');
        if (parameter[0]) map[parameter[0]] = parameter[1];
      }
    }

    for (i = 0; i < parameters.length; i++) {
      map[parameters[i].name] = encodeURIComponent(parameters[i].value);
    }

    for (i in map) {
      if (Object.prototype.hasOwnProperty.call(map, i)) {
        newParameters.push(i + '=' + map[i]);
      }
    }

    return base + '?' + newParameters.join('&');
  }

  function fillSelects(data) {
    var $docs = $('#custom_docs_ship');
    var $provinces = $('#custom_provinces_ship');
    var $cities = $('#custom_cities_ship');

    if (!$docs.length || !$provinces.length) return;

    if ($docs.find('option').length <= 1) {
      data.documents.forEach(function (doc) {
        $docs.append(
          $('<option></option>').attr('value', doc.code).text(doc.name)
        );
      });
    }

    if ($provinces.find('option').length <= 1) {
      data.provinces.forEach(function (province) {
        $provinces.append(
          $('<option></option>')
            .attr('value', province.code)
            .attr('name', province.shopifycode)
            .text(province.name)
        );
      });
    }

    var provinceValue =
      localStorage.getItem('province') ||
      (data.saved && data.saved.departamento) ||
      '';
    var cityValue =
      localStorage.getItem('city') ||
      (data.saved && data.saved.ciudad) ||
      '';
    var tipodocValue =
      localStorage.getItem('tipodoc') ||
      (data.saved && data.saved.tipodoc) ||
      '';

    if (tipodocValue) {
      $docs.val(tipodocValue).trigger('change');
    }

    if (provinceValue) {
      $provinces.val(provinceValue).trigger('change');
      if (cityValue) $cities.val(cityValue);
    } else {
      $provinces.val('05').trigger('change');
    }
  }

  function restoreFieldValues() {
    var docnumValue = localStorage.getItem('docnum') || '';
    var firstNameValue = localStorage.getItem('firstName') || '';
    var lastName1Value = localStorage.getItem('lastName1') || '';
    var lastName2Value = localStorage.getItem('lastName2') || '';

    if (docnumValue && !$('#docnum').val()) $('#docnum').val(docnumValue);
    if (firstNameValue && !$('#firstName').val()) $('#firstName').val(firstNameValue);
    if (lastName1Value && !$('#lastName1').val()) $('#lastName1').val(lastName1Value);
    if (lastName2Value && !$('#lastName2').val()) $('#lastName2').val(lastName2Value);
  }

  function applyDocTypeUI(selectDoc) {
    var textChange = document.getElementById('textName');
    var textDoc = document.getElementById('textDoc');
    var firstName = document.getElementById('firstName');

    if (!selectDoc || !textChange || !textDoc || !firstName) return;

    if (selectDoc.value === 'NIT') {
      $('#contentLastName1').hide();
      $('#contentLastName2').hide();
      textChange.innerText = 'RAZÓN SOCIAL';
      textDoc.innerText = 'NÚMERO DE DOCUMENTO (Sin dígito de verificación)';
      firstName.placeholder = 'Razón Social';
      $('#lastName1, #lastName2').prop('required', false);
    } else {
      $('#contentLastName1').show();
      $('#contentLastName2').show();
      textChange.innerText = 'NOMBRE (Si tiene más de un nombre por favor indicarlos)';
      textDoc.innerText = 'NÚMERO DOCUMENTO';
      firstName.placeholder = 'Nombre';
      $('#lastName1, #lastName2').prop('required', true);
    }
  }

  function validateAndPrepareCheckout(e) {
    var selectDoc = document.getElementById('custom_docs_ship');
    var form = document.getElementById('cartform');

    if (!selectDoc || !form || !$('#cart-city-form').length) return true;

    if (
      !$('#custom_cities_ship').val() ||
      $('#custom_cities_ship').val() === 'Seleccione...' ||
      $('#custom_cities_ship').val().length === 0
    ) {
      e.preventDefault();
      e.stopPropagation();
      showErrorMsg('Debe seleccionar una ciudad');
      return false;
    }

    if ($('#docnum').val().length === 0) {
      e.preventDefault();
      e.stopPropagation();
      showErrorMsg('Debe ingresar el número de documento');
      return false;
    }

    if ($('#firstName').val().length === 0) {
      e.preventDefault();
      e.stopPropagation();
      showErrorMsg(
        selectDoc.value === 'NIT'
          ? 'Debe ingresar Razón Social'
          : 'Debe ingresar el Nombre'
      );
      return false;
    }

    if (selectDoc.value !== 'NIT' && $('#lastName1').val().length === 0) {
      e.preventDefault();
      e.stopPropagation();
      showErrorMsg('Debe ingresar el Primer Apellido');
      return false;
    }

    if (selectDoc.value !== 'NIT' && $('#lastName2').val().length === 0) {
      e.preventDefault();
      e.stopPropagation();
      showErrorMsg('Debe ingresar el Segundo Apellido');
      return false;
    }

    var countDocument = $('#docnum').val().length;

    if (selectDoc.value === 'CC' && (countDocument < 6 || countDocument > 10)) {
      e.preventDefault();
      e.stopPropagation();
      showErrorMsg(
        'Cantidad de caracteres incorrecta para una cédula de ciudadanía. Debe ser entre 6 y 10 dígitos'
      );
      return false;
    }

    if (selectDoc.value === 'CE' && countDocument !== 6) {
      e.preventDefault();
      e.stopPropagation();
      showErrorMsg(
        'Cantidad de caracteres incorrecta para una cédula de extranjería. Debe ser entre 6 dígitos'
      );
      return false;
    }

    if (selectDoc.value === 'NIT' && countDocument !== 9) {
      e.preventDefault();
      e.stopPropagation();
      showErrorMsg(
        'Cantidad de caracteres incorrecta para un NIT. Debe ser máximo de 9 dígitos'
      );
      return false;
    }

    localStorage.setItem('docnum', $('#docnum').val());
    localStorage.setItem('firstName', $('#firstName').val());
    localStorage.setItem('lastName1', $('#lastName1').val());
    localStorage.setItem('lastName2', $('#lastName2').val());
    localStorage.setItem('tipodoc', selectDoc.value);
    localStorage.setItem('province', $('#custom_provinces_ship option:selected').val());
    localStorage.setItem('city', $('#custom_cities_ship option:selected').val());

    var parameters = [];
    var lastNameText = $('#lastName1').val() + ' ' + $('#lastName2').val();

    parameters.push({
      name: 'checkout[shipping_address][company]',
      value: $('#docnum').val()
    });
    parameters.push({
      name: 'checkout[shipping_address][first_name]',
      value: $('#firstName').val()
    });

    if (selectDoc.value !== 'NIT') {
      parameters.push({
        name: 'checkout[shipping_address][last_name]',
        value: lastNameText
      });
    }

    parameters.push({ name: 'checkout[shipping_address][country]', value: 'CO' });
    parameters.push({
      name: 'checkout[shipping_address][province]',
      value: $('#custom_provinces_ship option:selected').attr('name')
    });
    parameters.push({
      name: 'checkout[shipping_address][city]',
      value: removeAccentsAndSpecialChars(
        $('#custom_cities_ship option:selected').text().toLowerCase()
      )
    });

    var postUrl = urlFormatter(form.getAttribute('action') || '/cart', parameters);
    form.setAttribute('action', postUrl);
    return true;
  }

  function init() {
    if (typeof jQuery === 'undefined') return;

    var data = getData();
    if (!data || !document.getElementById('cart-city-form')) return;

    if (!initialized) {
      $(document).on('keydown', '#docnum', function (event) {
        var selectDoc = document.getElementById('custom_docs_ship');
        if (!selectDoc || selectDoc.value === 'PA') return;
        if (
          (event.keyCode < 48 || event.keyCode > 57) &&
          (event.keyCode < 96 || event.keyCode > 105) &&
          event.keyCode !== 110 &&
          event.keyCode !== 8 &&
          event.keyCode !== 9
        ) {
          return false;
        }
      });

      $(document).on('change', '#custom_docs_ship', function () {
        applyDocTypeUI(this);
        localStorage.setItem('tipodoc', this.value);
      });

      $(document).on('change', '#custom_provinces_ship', function () {
        var liveData = getData();
        var liveCities = (liveData && liveData.cities) || [];
        var provinceId = $(this).val();
        var cities = liveCities.filter(function (city) {
          return city.province == provinceId;
        });

        var $cities = $('#custom_cities_ship');
        $cities.empty().append('<option value="">Seleccione...</option>');
        cities.forEach(function (city) {
          $cities.append(
            $('<option></option>').attr('value', city.code).text(city.name)
          );
        });
      });

      $(document).on('submit', '#cartform', function (e) {
        var submitter =
          (e.originalEvent && e.originalEvent.submitter) || document.activeElement;
        if (submitter && submitter.getAttribute('name') === 'update') return;
        if (!$(this).find('#cart-city-form').length) return;
        return validateAndPrepareCheckout(e);
      });

      initialized = true;
    }

    fillSelects(data);
    restoreFieldValues();
    applyDocTypeUI(document.getElementById('custom_docs_ship'));
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('theme:cartchanged', function () {
    setTimeout(init, 300);
  });
})();
